export default __webpack_public_path__ + "static/media/kitchen1-2048w.24df764e.avif";